import { propertyDraftQueryKeys as e } from "./propertyDraftQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertyDraftsApi as n } from "@maat/api-main";
//#region src/propertyDrafts/usePropertyDraftsQuery.ts
var r = (r) => t({
	queryKey: e.list(),
	queryFn: () => n.getDrafts(),
	enabled: r?.enabled ?? !0
});
//#endregion
export { r as usePropertyDraftsQuery };
